export interface DocumentState {
  country: string;
  countryCode: string;
  documentType: string;
  supportedDocuments: Array<SupportedDocument>;
}

export enum DocumentType {
  DRIVERSLICENSE = "DRIVERSLICENSE",
  NATIONALID = "NATIONALID",
  PASSPORT = "PASSPORT",
}

export enum DocumentSide {
  FRONT = "FRONT",
  BACK = "BACK",
  DUAL = "DUAL",
}

export interface UploadPayload extends FormData {
  applicantId?: string;
  publicKey?: string;
  file?: string;
  type?: DocumentType;
  side?: DocumentSide;
  iso2CountryCode?: string;
  taxId?: string;
}

export interface CountryPayload {
  countryCode: string;
  country: string;
  supportedDocuments: Array<SupportedDocument>;
}

export interface DocumentPayload {
  documentType: DocumentType;
}

export interface SupportedDocument {
  name: string;
  type: DocumentType;
}
